var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.047,
    height: 112.431,
    viewBox: "0 0 111.047 112.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.047,
    height: 112.431,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-371 -3402.881)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    transform: "translate(371 3403.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(371 3402.881)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.523,0C24.858,0,0,25.169,0,56.216s24.858,56.215,55.523,56.215,55.523-25.168,55.523-56.215S86.188,0,55.523,0m0,108.332C27.094,108.332,4.048,85,4.048,56.216S27.094,4.1,55.523,4.1,107,27.432,107,56.216s-23.046,52.116-51.475,52.116",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.523,4.1C27.094,4.1,4.048,27.432,4.048,56.215s23.046,52.117,51.475,52.117S107,85,107,56.215,83.952,4.1,55.523,4.1m0,102.476c-27.47,0-49.74-22.547-49.74-50.36S28.053,5.856,55.523,5.856s49.74,22.546,49.74,50.359-22.27,50.36-49.74,50.36",
    fill: "#0081cc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.313,
    height: 5.27,
    transform: "translate(54.367 7.613)",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.313,
    height: 5.27,
    transform: "translate(54.367 99.548)",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.205,
    height: 2.342,
    transform: "translate(98.322 55.044)",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.205,
    height: 2.342,
    transform: "translate(7.519 55.044)",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.409,19.579l-1.988-1.2,2.662-4.529,1.988,1.2Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.963,98.579l-1.988-1.2,2.663-4.529,1.987,1.2Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.709,79.386l1.183-2.013,4.473,2.7-1.183,2.013Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.682,32.362l1.183-2.013,4.473,2.7-1.183,2.013Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.128,35.491l-1.161-2.026,4.5-2.644,1.161,2.026Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.576,81.61l-1.161-2.026,4.5-2.644,1.161,2.026Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.992,94.289l2-1.175,2.612,4.559-2,1.175Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.442,14.757l2-1.175,2.611,4.559-2,1.175Z",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.355,56.728A3.76,3.76,0,1,1,55.6,52.922a3.783,3.783,0,0,1,3.759,3.806",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.451,56.874h0a.868.868,0,0,1-.868-.868V16.165a.868.868,0,0,1,1.736,0V56.006a.868.868,0,0,1-.868.868",
    fill: "#00a8da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.669,85.1h0a.879.879,0,0,1-.322-1.2L53.085,58.372a.878.878,0,1,1,1.521.878L39.869,84.776a.878.878,0,0,1-1.2.322",
    fill: "#00a8da"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon01);
export default __webpack_public_path__ + "static/media/time_icon01.f14c96ac3e80ba8dd5d5d2ab033ce083.svg";
export { ForwardRef as ReactComponent };